// store
import { fromJS, List, Map } from 'immutable'
import { handleActions } from 'redux-actions'
import Psfs from 'lib/psfs/Psfs'
import { PROJECTED_SITES_MANAGER } from 'constants/appRouting'
import ActionHelper from 'helpers/action'

// constants
export const CLEAR_STORE = 'projectedSitesManager/CLEAR_STORE'
export const SET_PSFS = 'projectedSitesManager/SET_PSFS'
export const SET_IS_SAVING_FORM = 'projectedSitesManager/SET_IS_SAVING_FORM'
export const SET_ACTIVE_SITE = 'projectedSitesManager/SET_ACTIVE_SITE'
export const CLEAR_ACTIVE_SITE = 'projectedSitesManager/CLEAR_ACTIVE_SITE'
export const SET_ACTIVE_SITE_ROW = 'projectedSitesManager/SET_ACTIVE_SITE_ROW'
export const CLEAR_ACTIVE_SITE_ROW =
  'projectedSitesManager/CLEAR_ACTIVE_SITE_ROW'
export const SUCCESS_PROJECTED_SITES_MANAGER_FILTERS =
  'projectedSitesManager/SUCCESS_PROJECTED_SITES_MANAGER_FILTERS'
export const FETCH_PROJECTED_SITES_MANAGER_LIST =
  'projectedSitesManager/FETCH_PROJECTED_SITES_MANAGER_LIST'
export const FETCH_PROJECTED_SITES_MANAGER_SINGLE_ITEM =
  'projectedSitesManager/FETCH_PROJECTED_SITES_MANAGER_SINGLE_ITEM'
export const FETCH_PROJECTED_SITES_MANAGER_FILTERS =
  'projectedSitesManager/FETCH_PROJECTED_SITES_MANAGER_FILTERS'
export const SAVE_LIST_FORM = 'projectedSitesManager/SAVE_LIST_FORM'
export const SAVE_SINGLE_ITEM_FORM =
  'projectedSitesManager/SAVE_SINGLE_ITEM_FORM'
export const SUCCESS_PROJECTED_SITES_MANAGER_LIST =
  'projectedSitesManager/SUCCESS_PROJECTED_SITES_MANAGER_LIST'
export const SUCCESS_PROJECTED_SITES_MANAGER_SINGLE_ITEM =
  'projectedSitesManager/SUCCESS_PROJECTED_SITES_MANAGER_SINGLE_ITEM'
export const SUCCESS_PROJECTED_SITES_MANAGER_ITEM_UPDATE =
  'projectedSitesManager/SUCCESS_PROJECTED_SITES_MANAGER_ITEM_UPDATE'
export const SUCCESS_PROJECTED_SITES_MANAGER_SINGLE_ITEM_UPDATE =
  'projectedSitesManager/SUCCESS_PROJECTED_SITES_MANAGER_SINGLE_ITEM_UPDATE'
export const FAILURE_PROJECTED_SITES_MANAGER_SINGLE_ITEM =
  'projectedSitesManager/FAILURE_PROJECTED_SITES_MANAGER_SINGLE_ITEM'
export const FAILURE_PROJECTED_SITES_MANAGER_SITE =
  'projectedSitesManager/FAILURE_PROJECTED_SITES_MANAGER_SITE'
export const SET_PROJECTED_SITES_MANAGER_SITE_LIST_LOADER =
  'projectedSitesManager/SET_PROJECTED_SITES_MANAGER_SITE_LIST_LOADER'
export const FETCH_PROJECTED_SITES_MANAGER_CLIENTS =
  'projectedSitesManager/FETCH_PROJECTED_SITES_MANAGER_CLIENTS'
export const SUCCESS_PROJECTED_SITES_MANAGER_CLIENTS =
  'projectedSitesManager/SUCCESS_PROJECTED_SITES_MANAGER_CLIENTS'
export const FETCH_PROJECTED_SITES_MANAGER_SITES =
  'projectedSitesManager/FETCH_PROJECTED_SITES_MANAGER_SITES'
export const FETCH_PROJECTED_SITES_MANAGER_BASE_PRODUCTS =
  'projectedSitesManager/FETCH_PROJECTED_SITES_MANAGER_BASE_PRODUCTS'
export const FETCH_PROJECTED_SITES_MANAGER_DIET_GROUPS =
  'projectedSitesManager/FETCH_PROJECTED_SITES_MANAGER_DIET_GROUPS'
export const FETCH_PROJECTED_SITES_MANAGER_PROJECTED_PRODUCTS =
  'projectedSitesManager/FETCH_PROJECTED_SITES_MANAGER_PROJECTED_PRODUCTS'
export const SUCCESS_PROJECTED_SITES_MANAGER_SITES =
  'projectedSitesManager/SUCCESS_PROJECTED_SITES_MANAGER_SITES'
export const SUCCESS_PROJECTED_SITES_MANAGER_BASE_PRODUCTS =
  'projectedSitesManager/SUCCESS_PROJECTED_SITES_MANAGER_BASE_PRODUCTS'
export const SUCCESS_PROJECTED_SITES_MANAGER_DIET_GROUPS =
  'projectedSitesManager/SUCCESS_PROJECTED_SITES_MANAGER_DIET_GROUPS'
export const SUCCESS_PROJECTED_SITES_MANAGER_PROJECTED_PRODUCTS =
  'projectedSitesManager/SUCCESS_PROJECTED_SITES_MANAGER_PROJECTED_PRODUCTS'
export const FETCH_PROJECTED_SITES_MANAGER_REGIONS =
  'projectedSitesManager/FETCH_PROJECTED_SITES_MANAGER_REGIONS'
export const SUCCESS_PROJECTED_SITES_MANAGER_REGIONS =
  'projectedSitesManager/SUCCESS_PROJECTED_SITES_MANAGER_REGIONS'
export const FETCH_PROJECTED_SITES_MANAGER_SPECIES =
  'projectedSitesManager/FETCH_PROJECTED_SITES_MANAGER_SPECIES'
export const SUCCESS_PROJECTED_SITES_MANAGER_SPECIES =
  'projectedSitesManager/SUCCESS_PROJECTED_SITES_MANAGER_SPECIES'
export const FETCH_PROJECTED_SITES_MANAGER_PRODUCT_FAMILY =
  'projectedSitesManager/FETCH_PROJECTED_SITES_MANAGER_PRODUCT_FAMILY'
export const SUCCESS_PROJECTED_SITES_MANAGER_PRODUCT_FAMILY =
  'projectedSitesManager/SUCCESS_PROJECTED_SITES_MANAGER_PRODUCT_FAMILY'
export const FETCH_PROJECTED_SITES_MANAGER_LOOKUP_TABLE_709 =
  'projectedSitesManager/FETCH_PROJECTED_SITES_MANAGER_LOOKUP_TABLE_709'
export const SUCCESS_PROJECTED_SITES_MANAGER_LOOKUP_TABLE_709 =
  'projectedSitesManager/SUCCESS_PROJECTED_SITES_MANAGER_LOOKUP_TABLE_709'
export const FETCH_PROJECTED_SITES_MANAGER_SNAPSHOTS =
  'projectedSitesManager/FETCH_PROJECTED_SITES_MANAGER_SNAPSHOTS'
export const SUCCESS_PROJECTED_SITES_MANAGER_SNAPSHOTS =
  'projectedSitesManager/SUCCESS_PROJECTED_SITES_MANAGER_SNAPSHOTS'
export const UPDATE_PROJECTED_SITES_MANAGER_SNAPSHOT =
  'projectedSitesManager/UPDATE_PROJECTED_SITES_MANAGER_SNAPSHOT'
export const SET_PROJECTED_SITES_MANAGER_SNAPSHOTS_LOADER =
  'projectedSitesManager/SET_PROJECTED_SITES_MANAGER_SNAPSHOTS_LOADER'
export const FETCH_PROJECTED_SITES_MANAGER_USERS_AND_GROUPS =
  'projectedSitesManager/FETCH_PROJECTED_SITES_MANAGER_USERS_AND_GROUPS'
export const SUCCESS_PROJECTED_SITES_MANAGER_USERS_AND_GROUPS =
  'projectedSitesManager/SUCCESS_PROJECTED_SITES_MANAGER_USERS_AND_GROUPS'
export const CLEAR_PSFS = 'projectedSitesManager/CLEAR_PSFS'

// actions
export const clearProjectedSitesManagerStore = ActionHelper.createActionObj(
  CLEAR_STORE,
)
export const setPsfs = ActionHelper.createActionObj(SET_PSFS)
export const setIsLoad = ActionHelper.createActionObj(
  SET_PROJECTED_SITES_MANAGER_SITE_LIST_LOADER,
)
export const setActiveSite = ActionHelper.createActionObj(SET_ACTIVE_SITE)
export const setActiveSiteRow = ActionHelper.createActionObj(
  SET_ACTIVE_SITE_ROW,
)
export const setBaseProducts = ActionHelper.createActionObj(
  SUCCESS_PROJECTED_SITES_MANAGER_BASE_PRODUCTS,
)
export const setDietGroups = ActionHelper.createActionObj(
  SUCCESS_PROJECTED_SITES_MANAGER_DIET_GROUPS,
)
export const setProjectedProducts = ActionHelper.createActionObj(
  SUCCESS_PROJECTED_SITES_MANAGER_PROJECTED_PRODUCTS,
)
export const clearActiveSite = ActionHelper.createActionObj(CLEAR_ACTIVE_SITE)
export const clearActiveSiteRow = ActionHelper.createActionObj(
  CLEAR_ACTIVE_SITE_ROW,
)
export const fetchProjectedSitesManagerList = ActionHelper.createActionObj(
  FETCH_PROJECTED_SITES_MANAGER_LIST,
)
export const fetchProjectedSitesManagerSingleItem = ActionHelper.createActionObj(
  FETCH_PROJECTED_SITES_MANAGER_SINGLE_ITEM,
)
export const fetchProjectedSitesManagerFilters = ActionHelper.createActionObj(
  FETCH_PROJECTED_SITES_MANAGER_FILTERS,
)
export const fetchProjectedSitesManagerClients = ActionHelper.createActionObj(
  FETCH_PROJECTED_SITES_MANAGER_CLIENTS,
)
export const fetchProjectedSitesManagerSites = ActionHelper.createActionObj(
  FETCH_PROJECTED_SITES_MANAGER_SITES,
)
export const fetchProjectedSitesManagerBaseProducts = ActionHelper.createActionObj(
  FETCH_PROJECTED_SITES_MANAGER_BASE_PRODUCTS,
)
export const fetchProjectedSitesManagerDietGroups = ActionHelper.createActionObj(
  FETCH_PROJECTED_SITES_MANAGER_DIET_GROUPS,
)
export const fetchProjectedSitesManagerProjectedProducts = ActionHelper.createActionObj(
  FETCH_PROJECTED_SITES_MANAGER_PROJECTED_PRODUCTS,
)
export const fetchProjectedSitesManagerRegions = ActionHelper.createActionObj(
  FETCH_PROJECTED_SITES_MANAGER_REGIONS,
)
export const fetchProjectedSitesManagerSpecies = ActionHelper.createActionObj(
  FETCH_PROJECTED_SITES_MANAGER_SPECIES,
)
export const fetchProjectedSitesManagerProductFamily = ActionHelper.createActionObj(
  FETCH_PROJECTED_SITES_MANAGER_PRODUCT_FAMILY,
)
export const fetchProjectedSitesManagerLookupTable709 = ActionHelper.createActionObj(
  FETCH_PROJECTED_SITES_MANAGER_LOOKUP_TABLE_709,
)
export const fetchProjectedSitesManagerSnapshots = ActionHelper.createActionObj(
  FETCH_PROJECTED_SITES_MANAGER_SNAPSHOTS,
)
export const fetchProjectedSitesManagerUsersAndGroups = ActionHelper.createActionObj(
  FETCH_PROJECTED_SITES_MANAGER_USERS_AND_GROUPS,
)
export const updateProjectedSitesManagerSnapshot = ActionHelper.createActionObj(
  UPDATE_PROJECTED_SITES_MANAGER_SNAPSHOT,
)
export const saveListForm = ActionHelper.createActionObj(SAVE_LIST_FORM)
export const saveSingleItemForm = ActionHelper.createActionObj(
  SAVE_SINGLE_ITEM_FORM,
)

export const clearPsfs = ActionHelper.createActionObj(CLEAR_PSFS)

// store
const initialState = () =>
  fromJS({
    listTableData: {
      data: [],
      count: 0,
    },
    singleItemTableData: {
      data: [],
      count: 0,
      graphs: {},
    },
    seawaterFilters: {
      clients: [],
      sites: [],
      regions: [],
      species: [],
    },
    freshwaterFilters: {
      clients: [],
    },
    clientsList: List([]),
    sitesList: List([]),
    regionsList: List([]),
    speciesList: List([]),
    productFamilyList: List([]),
    baseProductList: List([]),
    dietGroupList: List([]),
    projectedProductList: List([]),
    singleItemFormLookup: Map({ Pigmento: [], Aditivos: [], Histidina: [] }),
    isLoadTable: true,
    isLoadSnapshots: false,
    formListLoader: false,
    isSavingForm: false,
    storePsfs: new Psfs(PROJECTED_SITES_MANAGER),
    activeSite: {
      id: null,
      clientId: null,
      clientName: null,
      client: null,
      siteId: null,
      site: null,
      region: null,
      specieId: null,
      specie: null,
      productFamilyId: null,
      stockingMonthYear: null,
      stockingFishCount: null,
      stockingWeight: null,
      monthsFromStocking: null,
      numberOfCages: null,
      harvestingMonthYear: null,
      harvestingLength: null,
      enabled: true,
    },
    activeSiteRow: {
      id: null,
      client: null,
      monthYear: null,
      predictedFeedConsumption: null,
      predictedSales: null,
      reason: null,
      region: null,
      site: null,
      sku: null,
      specie: null,
      userProjectedBaseProduct: null,
      userProjectedBaseProductId: null,
      userProjectedDietGroupId: null,
      userProjectedFeedConsumption: null,
      userProjectedProduct: null,
      userProjectedProductId: null,
      userProjectedProductFamily: null,
      userProjectedProductFamilyId: null,
      userProjectedSales: null,
      userProjectedPigment: null,
      userProjectedAdditives: null,
      userProjectedHistidine: null,
    },
    snapshots: List([]),
    usersAndGroups: {},
  })

const ProjectedSitesManager = handleActions(
  {
    [CLEAR_STORE]: () => initialState(),
    [SET_PSFS]: (state, action) => state.set('storePsfs', action.payload),
    [SET_PROJECTED_SITES_MANAGER_SITE_LIST_LOADER]: (state, action) =>
      state.set('isLoadTable', Boolean(action.payload)),
    [SUCCESS_PROJECTED_SITES_MANAGER_LIST]: (state, action) =>
      state
        .set('listTableData', Map(action.payload))
        .set('formListLoader', false),
    [SUCCESS_PROJECTED_SITES_MANAGER_SINGLE_ITEM]: (state, action) =>
      state
        .set('singleItemTableData', Map(action.payload))
        .set('formListLoader', false),
    [SUCCESS_PROJECTED_SITES_MANAGER_ITEM_UPDATE]: (state, action) => {
      const {
        listTableData: { data: oldData },
        listTableData,
      } = state.toJS()
      const newData = [action.payload]
      const newArr = oldData.map(
        obj => newData.find(newObj => newObj.id === obj.id) || obj,
      )
      listTableData.data = newArr

      return state
        .set('listTableData', Map(listTableData))
        .set('formListLoader', false)
    },
    [SUCCESS_PROJECTED_SITES_MANAGER_SINGLE_ITEM_UPDATE]: (state, action) => {
      const {
        singleItemTableData: { data: oldData },
        singleItemTableData,
      } = state.toJS()
      const newData = [action.payload]
      const newArr = oldData.map(
        obj => newData.find(newObj => newObj.id === obj.id) || obj,
      )
      singleItemTableData.data = newArr

      return state
        .set('singleItemTableData', Map(singleItemTableData))
        .set('formListLoader', false)
    },
    [FAILURE_PROJECTED_SITES_MANAGER_SINGLE_ITEM]: state =>
      state
        .set('singleItemTableData', Map({ data: [], count: 0, graphs: {} }))
        .set('formListLoader', false),
    [FAILURE_PROJECTED_SITES_MANAGER_SITE]: state =>
      state
        .set('listTableData', Map({ data: [], count: 0 }))
        .set('formListLoader', false),
    [SUCCESS_PROJECTED_SITES_MANAGER_FILTERS]: (state, action) =>
      state.set('seawaterFilters', Map(action.payload)),
    [SUCCESS_PROJECTED_SITES_MANAGER_REGIONS]: (state, action) =>
      state.set('regionsList', List(action.payload)),
    [SUCCESS_PROJECTED_SITES_MANAGER_SITES]: (state, action) =>
      state.set('sitesList', List(action.payload)),
    [SUCCESS_PROJECTED_SITES_MANAGER_BASE_PRODUCTS]: (state, action) =>
      state.set('baseProductList', List(action.payload)),
    [SUCCESS_PROJECTED_SITES_MANAGER_DIET_GROUPS]: (state, action) =>
      state.set('dietGroupList', List(action.payload)),
    [SUCCESS_PROJECTED_SITES_MANAGER_PROJECTED_PRODUCTS]: (state, action) =>
      state.set('projectedProductList', List(action.payload)),
    [SUCCESS_PROJECTED_SITES_MANAGER_CLIENTS]: (state, action) =>
      state.set('clientsList', List(action.payload)).set(
        'freshwaterFilters',
        Map({
          clients: action.payload,
        }),
      ),
    [SUCCESS_PROJECTED_SITES_MANAGER_SPECIES]: (state, action) =>
      state.set('speciesList', List(action.payload)),
    [SUCCESS_PROJECTED_SITES_MANAGER_PRODUCT_FAMILY]: (state, action) =>
      state.set('productFamilyList', List(action.payload)),
    [SUCCESS_PROJECTED_SITES_MANAGER_LOOKUP_TABLE_709]: (state, action) =>
      state.set('singleItemFormLookup', Map(action.payload)),
    [SET_PROJECTED_SITES_MANAGER_SNAPSHOTS_LOADER]: (state, action) =>
      state.set('isLoadSnapshots', Boolean(action.payload)),
    [SUCCESS_PROJECTED_SITES_MANAGER_SNAPSHOTS]: (state, action) =>
      state.set('snapshots', List(action.payload)),
    [SUCCESS_PROJECTED_SITES_MANAGER_USERS_AND_GROUPS]: (state, action) =>
      state.set('usersAndGroups', Map(action.payload)),
    [SET_IS_SAVING_FORM]: (state, action) =>
      state.set('isSavingForm', Boolean(action.payload)),
    [SET_ACTIVE_SITE]: (state, action) =>
      state.set('activeSite', {
        ...state.get('activeSite'),
        ...action.payload,
      }),
    [CLEAR_ACTIVE_SITE]: state =>
      state.set('activeSite', initialState().get('activeSite')),
    [SET_ACTIVE_SITE_ROW]: (state, action) =>
      state.set('activeSiteRow', {
        ...state.get('activeSiteRow'),
        ...action.payload,
      }),
    [CLEAR_ACTIVE_SITE_ROW]: state =>
      state.set('activeSiteRow', initialState().get('activeSiteRow')),
    [CLEAR_PSFS]: state =>
      state.set('storePsfs', initialState().get('storePsfs')),
  },
  initialState(),
)

export default ProjectedSitesManager
